import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaSave } from "react-icons/fa";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
const Foodbillingandsetup = () => {
    const { showLoader, hideLoader } = useLoader();
    const billingFields = [
        { label: "Delivery PlatformCharges", key: "deliveryplatformCharges" },
        { label: "Delivery Charges", key: "deliveryCharges" },
        { label: "Commission Charges", key: "commissionCharges" },
        { label: "Dinein PlatformCharges", key: "dineinPlatformCharges" },
        { label: "Table PlatformCharges", key: "tableplatformCharges" },
        { label: "Take away PlatformCharges", key: "takeawayplatformCharges" },
        { label: "CouponAmount Charges", key: "couponAmount" },
        { label: "Promotion Charges", key: "promotionCharge" },
        { label: "TopRated Charges", key: "topRatedCharge" },
        { label: "discount Percentage", key: "discountPercentage" },
        { label: "Platform Charges Gst", key: "platformchargeGst" },
        { label: "Commission Charges Gst", key: "commissionGst" },
        { label: "Packaging Charges GST", key: "packagingChargeGst" },
        { label: "Service Charges Gst", key: "serviceChargeGst" },
        { label: "Delivery Radius (KM)", key: "deliveryRadius" },
    ];

    const [billingData, setBillingData] = useState({});
    const [editMode, setEditMode] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchBillingData();
    }, []);

    const fetchBillingData = async () => {
        try {
            showLoader();
            const parentId = localStorage.getItem("userId");
            const token = localStorage.getItem("authToken");
            if (!token) {
                console.error("❌ Auth token not found in localStorage");
                return;
            }

            const url = `https://backend.maamaas.com/food/api/admin-billing/admin/1`;
            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setBillingData(response.data || {});
        } catch (error) {
            console.error("❌ Error fetching billing data:", error);
        } finally {
            hideLoader();
        }
    };

    const toggleEdit = (key) => {
        setEditMode((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const handleValueChange = (key, value) => {
        setBillingData((prev) => ({ ...prev, [key]: value }));
    };

    const handleCheckboxChange = (key) => {
        setBillingData((prev) => ({ ...prev, [`${key}Visibility`]: !prev[`${key}Visibility`] }));
    };

    const handleSave = async (key) => {
        setLoading(true);
        try {
            showLoader();
            const token = localStorage.getItem("authToken");
            const userId = localStorage.getItem("userId");

            const payload = {

                adminId: 1,
                ...billingData,
            };


            const url = `https://backend.maamaas.com/food/api/admin-billing/add`;
            const response = await axios.post(url, payload, {
                headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
            });

            alert("Billing settings saved successfully!");
            if (key) setEditMode((prev) => ({ ...prev, [key]: false }));
            else setEditMode({});
        } catch (error) {
            console.error("❌ Error saving billing data:", error.response?.data || error.message);
            alert(`Failed to save billing settings: ${error.response?.data?.message || error.message}`);
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    return (
        <div style={containerStyle}>
            <table style={tableStyle}>
                <thead>
                    <tr>
                        <th style={headerStyle}>Charge Type</th>
                        <th style={headerStyle}>Rupees (₹)</th>
                        <th style={headerStyle}>Visibility</th>
                        <th style={headerStyle}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {billingFields.map(({ label, key }) => (
                        <tr key={key}>
                            <td style={cellStyle}><strong>{label}</strong></td>
                            <td style={cellStyle}>
                                {editMode[key] ? (
                                    <input
                                        type="number"
                                        value={billingData[key] || ""}
                                        onChange={(e) => handleValueChange(key, e.target.value)}
                                        style={inputStyle}
                                    />
                                ) : (
                                    <span>{billingData[key] || "—"}</span>
                                )}
                            </td>
                            <td style={cellStyle}>
                                <input
                                    type="checkbox"
                                    checked={billingData[`${key}Visibility`] || false}
                                    onChange={() => handleCheckboxChange(key)}
                                    disabled={[
                                        "couponAmount",
                                        "platformchargeGst",
                                        "commissionGst",
                                        "packagingChargeGst",
                                        "serviceChargeGst",
                                        "promotionCharge",
                                        "topRatedCharge",
                                        "discountPercentage",
                                        "deliveryRadius",
                                    ].includes(key)}
                                />
                            </td>
                            <td style={cellStyle}>
                                {editMode[key] ? (
                                    <FaSave
                                        onClick={() => handleSave(key)}
                                        style={{ ...iconStyle, color: "#4caf50" }}
                                        title="Save"
                                    />
                                ) : (
                                    <FaEdit
                                        onClick={() => toggleEdit(key)}
                                        style={iconStyle}
                                        title="Edit"
                                    />
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>

            </table>

            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "20px"
                }}
            >
                <button
                    onClick={() => handleSave()}
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "#4CAF50",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontWeight: "bold",
                        transition: "background-color 0.3s"
                    }}
                    onMouseOver={e => (e.target.style.backgroundColor = "#45a049")}
                    onMouseOut={e => (e.target.style.backgroundColor = "#4CAF50")}
                >
                    Save
                </button>
            </div>

        </div>
    );
};

// Styles
const containerStyle = { maxWidth: "1200px", margin: "0 auto", fontFamily: "Segoe UI, sans-serif", padding: "0px" };
const tableStyle = { width: "100%", borderCollapse: "collapse" };
const headerStyle = { background: "#b15cd6", color: "#fff", padding: "10px", border: "1px solid #ddd", textAlign: "center" };
const cellStyle = { padding: "10px", border: "1px solid #ddd", textAlign: "center" };
const inputStyle = { width: "100px", padding: "5px", border: "1px solid #ccc", borderRadius: "5px", textAlign: "center" };
const iconStyle = { fontSize: "18px", cursor: "pointer" };

export default Foodbillingandsetup;
